import useFeatureFlag from 'hooks/useFeatureFlags'
import useHomeType from 'hooks/useHomeType'
import styled from 'styled-components'
import RotaPaywall from '../components/RotaPaywall/RotaPaywall'

export const RotaPaywallScreen = () => {
  const { hasRota } = useHomeType()

  const flags = useFeatureFlag({
    flagNames: ['rostering_paywall_screen'],
  })?.data

  const flagRosteringPaywallScreenEnabled =
    flags?.rostering_paywall_screen?.enabled

  if (hasRota || !flagRosteringPaywallScreenEnabled) {
    return null
  }

  return (
    <PageContainer>
      <RotaPaywall />
    </PageContainer>
  )
}

const PageContainer = styled.div`
  padding: 24px 48px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 1080px;
  margin-left: auto;
  margin-right: auto;
`
